import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { updateTeacherProfile } from "../../../../store/actions/teacher";
import { CURRENCIES } from "../../../../utils/constants";
import styles from "./styles.module.css";
import commonStyles from "../styles.module.css";

const CurrencySettings = (props) => {
    const dispatch = useDispatch();
    const [currency, setCurrency] = useState("INR");

    useEffect(() => {
        if (props.myDetails?.currencyPreference) {
            setCurrency(props.myDetails.currencyPreference);
        }
    }, [props.myDetails]);

    const handleSubmit = async () => {
        let form = new FormData();
        form.append("type", "currencyPreference");
        form.append("teacherId", props.myDetails?.id);
        form.append("currencyCode", currency);

        try {
            if (document.getElementById("loader")) document.getElementById("loader").style.display = "flex";
            const res = await dispatch(updateTeacherProfile(form));
            if (document.getElementById("loader")) document.getElementById("loader").style.display = "none";

            if (res?.success || res?.status === 1) {
                toast.success("Currency Preference Updated");
                if (props.setApiCalled) props.setApiCalled(false);
            } else {
                toast.error(res?.message || "Update failed");
            }
        } catch (e) {
            console.error(e);
            if (document.getElementById("loader")) document.getElementById("loader").style.display = "none";
            toast.error("An error occurred");
        }
    };

    return (
        <div className={styles.basicInfo}>
            <h3 style={{ marginBottom: '20px', color: '#349ed2' }}>Currency Preference</h3>
            <p style={{ marginBottom: '20px', color: '#666', fontSize: '0.9rem' }}>
                Select your preferred currency for earnings and payouts.
            </p>
            <div className={commonStyles.formGroup}>
                <label>Select Currency</label>
                <select value={currency} onChange={(e) => setCurrency(e.target.value)}>
                    {CURRENCIES.map((curr) => (
                        <option key={curr.code} value={curr.code}>
                            {curr.code} ({curr.symbol})
                        </option>
                    ))}
                </select>
            </div>
            <div className={commonStyles.submitButtonContainer}>
                <button className={commonStyles.submitButton} onClick={handleSubmit}>
                    Save Preference
                </button>
            </div>
        </div>
    );
};

export default CurrencySettings;
